export default __webpack_public_path__ + "static/media/button_off.cd882c5e.svg";